/* eslint-disable no-case-declarations */
import { ModerationReportViewMode } from "../../types/Constants";
import {
  ModerationActions,
  GET_QUEUES,
  GET_REPORT_HISTORY,
  SET_REPORT_VIEW_TYPE
} from "../../types/actions/Moderation.actions";
import { ModerationState } from "../../types/models/ModerationState";

const initialSettings: ModerationState = {
  queue: undefined,
  history: undefined,
  viewMode: ModerationReportViewMode.Queue
};

const ModerationReducer = (state = initialSettings, action: ModerationActions) => {

  switch (action.type) {
    case GET_QUEUES:
      return {
        ...state,
        queue: action.payload
      };
    case GET_REPORT_HISTORY:
      return {
        ...state,
        history: action.payload
      };
    case SET_REPORT_VIEW_TYPE:
      return {
        ...state,
        viewMode: action.payload
      };
    default:
      return state;
  }
};

export default ModerationReducer;
